import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

// 设置字段数据源的字段名
export const getLabel = computed(
  () =>
    (props: {value?:string, label?:string} = { value: 'value', label: 'label' }) =>
      props.label
)
// 设置字段数据的值
export const getValue = computed(
  () =>
    (props: {value?:string, label?:string} = { value: 'value', label: 'label' }) =>
      props.value
)
interface Rule {
  type?: string
  message?: string
  required?: boolean
  trigger?: string[]
  custom?: Rule
}
// 定义表单的校验规则
export const getFormItemRules = (required:boolean|undefined,formItem: any) => {
  const { t } = useI18n()
  const requiredMessage = (label?: string) => t('cmform.requiredMessage', { label: label ?? '' })
  const rules: Rule[] = []
  ;(formItem.required ?? required) && rules.push({
    required: formItem.required ?? required,
    message: requiredMessage(formItem?.label),
    trigger: formItem.trigger ?? ['blur', 'change']
  })
  formItem?.rules?.forEach?.((rule: Rule) => {
    (rule.required ?? formItem.required ?? required ) && rules.push({
      required: rule.required ?? formItem.required ?? required,
      message: rule.message ?? requiredMessage(formItem?.label),
      trigger: rule.trigger ?? ['blur', 'change']
    })
    rule.type &&
      rules.push({
        type: rule.type,
        message: rule.message,
        trigger: rule.trigger ?? ['blur', 'change']
      })
    rule.custom && rules.push(rule.custom)
  })
  return rules
}
// 前端实现数据分页
export const getPageData = (data: any, page: number, pageSize: number) => {
  return data.slice((page - 1) * pageSize, page * pageSize)
}
// 时间转换
// 返回十位的时间戳格式
// 参数时间戳 T00:00:00Z 和T00:00:00的区别前者会多八个小时，因为中国相对时间时间来说在东八时区，后者则是使用世界时间
export const useParseTime = (daterange: string[]) => {
  const dateRange: number[] = []
  if (daterange && daterange.length >= 2 && daterange[0] && daterange[1]) {
    const start = new Date(daterange[0] + 'T00:00:00').getTime() / 1000
    const end = new Date(daterange[1] + 'T23:59:59').getTime() / 1000
    if (Number.isFinite(start) && Number.isFinite(end)) {
      dateRange[0] = start
      dateRange[1] = end
    }
  }
  return [dateRange[0], dateRange[1]]
}
